import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryQrIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.8 0.25H17.5C17.09 0.25 16.75 0.59 16.75 1C16.75 1.41 17.09 1.75 17.5 1.75H20.8C21.6 1.75 22.25 2.4 22.25 3.2V6.5C22.25 6.91 22.59 7.25 23 7.25C23.41 7.25 23.75 6.91 23.75 6.5V3.2C23.75 1.57 22.43 0.25 20.8 0.25Z"
        fill={color}
      />
      <path
        d="M1 7.25C1.41 7.25 1.75 6.91 1.75 6.5V3.2C1.75 2.4 2.4 1.75 3.2 1.75H6.5C6.91 1.75 7.25 1.41 7.25 1C7.25 0.59 6.91 0.25 6.5 0.25H3.2C1.57 0.25 0.25 1.57 0.25 3.2V6.5C0.25 6.91 0.59 7.25 1 7.25Z"
        fill={color}
      />
      <path
        d="M23 16.75C22.59 16.75 22.25 17.09 22.25 17.5V20.8C22.25 21.6 21.6 22.25 20.8 22.25H17.5C17.09 22.25 16.75 22.59 16.75 23C16.75 23.41 17.09 23.75 17.5 23.75H20.8C22.43 23.75 23.75 22.43 23.75 20.8V17.5C23.75 17.09 23.41 16.75 23 16.75Z"
        fill={color}
      />
      <path
        d="M6.5 22.25H3.2C2.4 22.25 1.75 21.6 1.75 20.8V17.5C1.75 17.09 1.41 16.75 1 16.75C0.59 16.75 0.25 17.09 0.25 17.5V20.8C0.25 22.43 1.57 23.75 3.2 23.75H6.5C6.91 23.75 7.25 23.41 7.25 23C7.25 22.59 6.91 22.25 6.5 22.25Z"
        fill={color}
      />
      <path
        d="M10.5 4.38H5C4.65 4.38 4.38 4.66 4.38 5V10.5C4.38 10.85 4.66 11.12 5 11.12H10.5C10.85 11.12 11.12 10.84 11.12 10.5V5C11.12 4.65 10.84 4.38 10.5 4.38ZM9.88 9.88H5.63V5.63H9.88V9.88Z"
        fill={color}
      />
      <path
        d="M13.5 11.12H19C19.34 11.12 19.62 10.84 19.62 10.5V5C19.62 4.65 19.34 4.38 19 4.38H13.5C13.16 4.38 12.88 4.66 12.88 5V10.5C12.88 10.85 13.16 11.12 13.5 11.12ZM14.12 5.62H18.37V9.87H14.12V5.62Z"
        fill={color}
      />
      <path
        d="M10.5 12.88H5C4.65 12.88 4.38 13.16 4.38 13.5V19C4.38 19.34 4.66 19.62 5 19.62H10.5C10.85 19.62 11.12 19.34 11.12 19V13.5C11.12 13.16 10.84 12.88 10.5 12.88ZM9.88 18.38H5.63V14.13H9.88V18.38Z"
        fill={color}
      />
      <path
        d="M14.51 12.88H13.5C13.1576 12.88 12.88 13.1576 12.88 13.5V14.51C12.88 14.8524 13.1576 15.13 13.5 15.13H14.51C14.8524 15.13 15.13 14.8524 15.13 14.51V13.5C15.13 13.1576 14.8524 12.88 14.51 12.88Z"
        fill={color}
      />
      <path
        d="M19.01 12.88H18C17.6576 12.88 17.38 13.1576 17.38 13.5V14.51C17.38 14.8524 17.6576 15.13 18 15.13H19.01C19.3524 15.13 19.63 14.8524 19.63 14.51V13.5C19.63 13.1576 19.3524 12.88 19.01 12.88Z"
        fill={color}
      />
      <path
        d="M16.75 15.12H15.74C15.3976 15.12 15.12 15.3976 15.12 15.74V16.75C15.12 17.0924 15.3976 17.37 15.74 17.37H16.75C17.0924 17.37 17.37 17.0924 17.37 16.75V15.74C17.37 15.3976 17.0924 15.12 16.75 15.12Z"
        fill={color}
      />
      <path
        d="M14.51 17.38H13.5C13.1576 17.38 12.88 17.6576 12.88 18V19.01C12.88 19.3524 13.1576 19.63 13.5 19.63H14.51C14.8524 19.63 15.13 19.3524 15.13 19.01V18C15.13 17.6576 14.8524 17.38 14.51 17.38Z"
        fill={color}
      />
      <path
        d="M19.01 17.38H18C17.6576 17.38 17.38 17.6576 17.38 18V19.01C17.38 19.3524 17.6576 19.63 18 19.63H19.01C19.3524 19.63 19.63 19.3524 19.63 19.01V18C19.63 17.6576 19.3524 17.38 19.01 17.38Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryQrIcon.displayName = 'LibraryQrIcon';
